export const GLOBAL_API_VERSION = "2020-06-16"
